"use client";

import Image from "next/image";
import { useTranslation } from "react-i18next";
import { NEW_IMAGES } from "@/lib/images";

export default function AboutEnablerSection() {
  const { t } = useTranslation();
  const [img1, img2, img3, img4, img5] = NEW_IMAGES.aboutEnabler;

  return (
    <section className="relative overflow-hidden border-y border-border-soft bg-gradient-to-b from-slate-50 via-white to-white py-16 sm:py-20 md:py-28">
      {/* Subtle grid texture */}
      <div
        className="pointer-events-none absolute inset-0 opacity-[0.35]"
        style={{
          backgroundImage: `linear-gradient(to right, rgb(226 232 240 / 0.45) 1px, transparent 1px),
            linear-gradient(to bottom, rgb(226 232 240 / 0.45) 1px, transparent 1px)`,
          backgroundSize: "48px 48px",
        }}
        aria-hidden
      />
      <div className="pointer-events-none absolute -right-24 top-1/2 h-[min(480px,50vh)] w-[min(480px,45vw)] -translate-y-1/2 rounded-full bg-primary/5 blur-3xl" aria-hidden />
      <div className="pointer-events-none absolute -left-16 bottom-0 h-64 w-64 rounded-full bg-primary-soft/60 blur-2xl" aria-hidden />

      <div className="relative mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16 xl:gap-20">
          {/* Copy */}
          <div className="order-2 max-w-xl lg:order-1 lg:max-w-none">
            <div className="mb-5 flex items-center gap-3 sm:mb-6">
              <span className="h-px w-10 shrink-0 bg-primary sm:w-12" aria-hidden />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-primary sm:text-sm">
                {t("common.brandName")}
              </span>
            </div>
            <h2 className="text-balance text-2xl font-bold leading-[1.15] tracking-tight text-slate-900 sm:text-3xl md:text-[2rem] lg:text-[2.25rem] xl:text-[2.5rem]">
              {t("about.enablerTitle")}
            </h2>
            <p className="mt-5 text-pretty text-base leading-relaxed text-slate-600 sm:mt-6 sm:text-lg">
              {t("about.enablerDesc")}
            </p>
          </div>

          {/* Image mosaic — aligned grid, no random rotation */}
          <div className="order-1 lg:order-2">
            <div className="mx-auto w-full max-w-xl lg:max-w-none">
              <div className="grid grid-cols-6 gap-2 sm:gap-3 md:gap-3.5">
                <div className="relative col-span-3 aspect-[4/3] overflow-hidden rounded-xl bg-slate-100 shadow-md ring-1 ring-slate-200/80 sm:rounded-2xl">
                  <Image
                    src={img1}
                    alt={t("images.aboutEnablerCommunity")}
                    fill
                    sizes="(max-width: 1024px) 50vw, 33vw"
                    className="object-cover transition duration-500 hover:scale-[1.02]"
                  />
                </div>
                <div className="relative col-span-3 aspect-[4/3] overflow-hidden rounded-xl bg-slate-100 shadow-md ring-1 ring-slate-200/80 sm:rounded-2xl">
                  <Image
                    src={img2}
                    alt={t("images.aboutEnablerGameTime")}
                    fill
                    sizes="(max-width: 1024px) 50vw, 33vw"
                    className="object-cover transition duration-500 hover:scale-[1.02]"
                  />
                </div>
                <div className="relative col-span-2 aspect-[4/3] overflow-hidden rounded-xl bg-slate-100 shadow-md ring-1 ring-slate-200/80 sm:rounded-2xl">
                  <Image
                    src={img3}
                    alt={t("images.aboutEnablerFacility")}
                    fill
                    sizes="(max-width: 1024px) 33vw, 22vw"
                    className="object-cover transition duration-500 hover:scale-[1.02]"
                  />
                </div>
                <div className="relative col-span-2 aspect-[4/3] overflow-hidden rounded-xl bg-slate-100 shadow-md ring-1 ring-slate-200/80 sm:rounded-2xl">
                  <Image
                    src={img4}
                    alt={t("images.aboutEnablerTeam")}
                    fill
                    sizes="(max-width: 1024px) 33vw, 22vw"
                    className="object-cover transition duration-500 hover:scale-[1.02]"
                  />
                </div>
                <div className="relative col-span-2 aspect-[4/3] overflow-hidden rounded-xl bg-slate-100 shadow-md ring-1 ring-slate-200/80 sm:rounded-2xl">
                  <Image
                    src={img5}
                    alt={t("images.aboutEnablerVenue")}
                    fill
                    sizes="(max-width: 1024px) 33vw, 22vw"
                    className="object-cover transition duration-500 hover:scale-[1.02]"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
